module.exports = __webpack_public_path__ + "static/media/home-icon-red.c59d2d05.png";